export default {
  logs: [],
  isLogsLoading: false,
  isLogsError: false
};
